import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CheckIcon from '../../v2/icons/CheckIcon';
import XIcon from '../../v2/icons/XIcon';
const CapabilityCircle = ({ checked }) => (React.createElement("div", { "data-testid": "div-9abddb6a", className: getCapabilityClassName(checked) },
    checked && React.createElement(CheckIcon, { className: "w-5 h-5 text-green" }),
    !checked && React.createElement(XIcon, { className: "w-4 h-4 text-red-400" })));
CapabilityCircle.propTypes = {
    checked: PropTypes.bool,
};
CapabilityCircle.defaultProps = {
    checked: false,
};
export default CapabilityCircle;
function getCapabilityClassName(value) {
    return classnames('flex-none', 'rounded-full', 'w-8', 'h-8', 'flex', 'justify-center', 'items-center', {
        'bg-green-50': value,
        'bg-red-50': !value,
    });
}
